
import { useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/layout/Layout";
import DashboardHeader from "@/components/dashboard/DashboardHeader";
import QuickAccessSection from "@/components/dashboard/QuickAccessSection";
import MainServiceCards from "@/components/dashboard/MainServiceCards";

const GeneralDashboard = () => {
  const { user } = useAuth();

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <DashboardHeader userName={user?.nome || ""} />
        <MainServiceCards />
        <QuickAccessSection />
      </div>
    </Layout>
  );
};

export default GeneralDashboard;
